/**
 * Downloads a blob as a file with the given file name.
 * To do this, we have to create an invisible link element, set the download attribute to the file name,
 * set the href attribute to the blob URL, and then click the link.
 * @param blob - The blob to download.
 * @param filename - The name of the file to download.
 *
 * @example
 * const blob = new Blob(['Hello, world!'], { type: 'text/plain' });
 * downloadBlobAsFile(blob, 'hello-world.txt');
 */

export function downloadBlobAsFile(blob: Blob, filename: string) {
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);

  link.setAttribute('style', 'display: none');
  link.setAttribute('download', filename);
  link.setAttribute('href', url);
  link.setAttribute('target', '_blank');

  document.body.appendChild(link);
  link.click();

  link.remove();
  URL.revokeObjectURL(url);
}
